export default "__VITE_ASSET__DkoI5JwR__"